import React from 'react'
import { Box, Skeleton } from '@mui/material'
import { StyledWidgetPieChartStatistic } from '../WidgetPieChartStatistic.styles'

const WidgetPieChartSkeleton = () => (
  <StyledWidgetPieChartStatistic>
    <Box width="100%" display="flex" justifyContent="flex-start" mb={2}>
      <Skeleton variant="text" width="50%" height={32} animation="wave" sx={{ borderRadius: 1, bgcolor: '#EFEFEF' }} />
    </Box>
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <Box sx={{ flexShrink: 0, width: { xs: 80, sm: 140 }, height: { xs: 80, sm: 140 } }}>
        <Skeleton variant="circular" width="100%" height="100%" animation="wave" sx={{ bgcolor: '#EFEFEF' }} />
      </Box>
      <Box sx={{ flex: '1 1 70%' }}>
        {[1, 2, 3, 4].map((item) => (
          <Box key={item} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <Skeleton variant="text" width="4%" height={20} animation="wave" sx={{ mr: 1, bgcolor: '#EFEFEF' }} />
            <Skeleton variant="text" width="60%" height={20} animation="wave" sx={{ bgcolor: '#EFEFEF' }} />
            <Skeleton variant="text" width="20%" height={20} animation="wave" sx={{ ml: 2, bgcolor: '#EFEFEF' }} />
          </Box>
        ))}
      </Box>
    </Box>
  </StyledWidgetPieChartStatistic>
)

export default WidgetPieChartSkeleton
